import { TrackRoute } from '@portals/shared-frontend/components';
import { type JSX } from 'react';

import DeveloperPortalGuideContent from '@/components/Guide/DeveloperPortalGuideContent';
import HeroPage from '@/components/HeroPage';

export default function OAuth2AuthenticationGuide(): JSX.Element {
  return (
    <HeroPage banner="common" noTopMargin title="OAuth2 Authentication">
      <TrackRoute name="OAuth2 Auth" path="/getting-started/oauth2-authentication" type="generic" />
      <DeveloperPortalGuideContent contentSlug="oauth2-authentication-internal" />
    </HeroPage>
  );
}
